export const PROMO_CODE_TYPE = 'PARTNER';

export const ACTIVE_USERS_PAGE_SIZE = 10;

export function normalizePromoUser(row) {
  if (!row || typeof row !== 'object') return null;
  return {
    userId: row.userId ?? row.user_id,
    fullName: row.fullName ?? row.full_name ?? '—',
    role: row.role,
    ordersCount: Number(row.ordersCount ?? row.orders_count ?? 0) || 0,
  };
}

export function toDatetimeLocalValue(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromDatetimeLocalValue(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

export function formatDisplayDate(iso, locale) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function filterPromoCodesByQuery(list, query) {
  const q = query.trim().toLowerCase();
  if (!q) return list;
  return list.filter((item) => String(item?.code ?? '').toLowerCase().includes(q));
}
